(function (window, document) {
  'use strict';

  var ProductCache = {
    _map: {},
    get: function (handle) {
      if (!handle) return Promise.reject(new Error('Missing handle'));
      if (this._map[handle]) return Promise.resolve(this._map[handle]);
      var self = this;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Product fetch failed');
          return r.json();
        })
        .then(function (json) {
          self._map[handle] = json;
          return json;
        });
    }
  };

  function optionNameAt(productJson, index) {
    var opt = productJson && productJson.options && productJson.options[index];
    if (!opt) return '';
    return typeof opt === 'string' ? opt : (opt.name || '');
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    var normalized = String(url);
    if (normalized.indexOf('//') === 0) normalized = 'https:' + normalized;
    return normalized;
  }

  function imageFileKey(url) {
    var normalized = normalizeImageUrl(url);
    var marker = '/files/';
    var idx = normalized.lastIndexOf(marker);
    if (idx < 0) return normalized;
    return normalized.slice(idx + marker.length).split('?')[0];
  }

  function imageUrlsMatch(a, b) {
    if (!a || !b) return false;
    return imageFileKey(a) === imageFileKey(b);
  }

  function shopifySizedImageUrl(url, width) {
    var normalized = normalizeImageUrl(url);
    if (!normalized) return '';
    var base = normalized.replace(/([?&])width=\d+/g, '').replace(/[?&]$/, '');
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return base + sep + 'width=' + width;
  }

  // Mirrors product-card.liquid variant gallery grouping (swatch slide + hero/gallery slides).
  function buildVariantGalleryMap(productJson) {
    var images = (productJson.images || []).map(normalizeImageUrl);
    var variants = productJson.variants || [];
    var map = {};
    var activeGalleryVariantId = null;

    images.forEach(function (url) {
      var imageVariantId = null;
      variants.some(function (v) {
        if (v.featured_image && imageUrlsMatch(url, v.featured_image.src)) {
          imageVariantId = String(v.id);
          return true;
        }
        return false;
      });

      if (imageVariantId) {
        activeGalleryVariantId = imageVariantId;
        if (!map[imageVariantId]) map[imageVariantId] = { swatch: url, gallery: [] };
        map[imageVariantId].swatch = url;
        return;
      }

      if (activeGalleryVariantId) {
        if (!map[activeGalleryVariantId]) map[activeGalleryVariantId] = { swatch: null, gallery: [] };
        map[activeGalleryVariantId].gallery.push(url);
      }
    });

    return map;
  }

  function getVariantGallerySlides(productJson, variantId) {
    var map = buildVariantGalleryMap(productJson);
    var entry = map[String(variantId)];
    if (!entry) {
      var variant = VariantResolver.byId(productJson, variantId);
      var fallback = variantImageSrc(variant);
      return fallback ? [fallback] : [];
    }

    var slides = entry.gallery.slice();
    var hero = slides.find(function (url) {
      return /hero/i.test(url);
    });
    if (hero) {
      slides = [hero].concat(slides.filter(function (url) {
        return url !== hero;
      }));
    }
    if (!slides.length && entry.swatch) slides = [entry.swatch];
    return slides;
  }

  function variantImageSrc(variant) {
    if (!variant) return '';
    if (variant.featured_image) {
      return variant.featured_image.src || variant.featured_image || '';
    }
    return '';
  }

  var VariantResolver = {
    find: function (productJson, selectedOptions) {
      if (!productJson || !productJson.variants) return null;
      if (productJson.variants.length === 1) return productJson.variants[0];
      var keys = Object.keys(selectedOptions || {});
      if (!keys.length) return null;
      return productJson.variants.find(function (variant) {
        return variant.options.every(function (opt, index) {
          var name = optionNameAt(productJson, index);
          return selectedOptions[name] === opt;
        });
      }) || null;
    },
    byId: function (productJson, variantId) {
      if (!productJson || !productJson.variants) return null;
      return productJson.variants.find(function (v) {
        return String(v.id) === String(variantId);
      }) || null;
    }
  };

  var Validator = {
    validate: function (state, groupsConfig, messages, displayProductId) {
      messages = messages || {};
      groupsConfig = groupsConfig || [];
      var shellProductId = displayProductId != null ? String(displayProductId) : null;
      if (!groupsConfig.length) {
        return {
          ok: false,
          message: messages.noGroups || 'This bundle is not configured yet.',
          reason: 'no_groups'
        };
      }
      for (var i = 0; i < groupsConfig.length; i++) {
        var g = groupsConfig[i];
        var entry = state.groups[g.id] || { selections: [] };
        var sels = entry.selections || [];
        if (g.selectionType === 'required' && sels.length < 1) {
          return {
            ok: false,
            message: messages.incompleteRequired || 'Please complete all required selections.',
            reason: 'incomplete'
          };
        }
        if (sels.length > g.maxSelection) {
          return {
            ok: false,
            message: messages.maxReached || 'You already selected the maximum for this group.',
            reason: 'max'
          };
        }
        for (var s = 0; s < sels.length; s++) {
          if (shellProductId && String(sels[s].productId) === shellProductId) {
            return {
              ok: false,
              message: messages.genericError || messages.noGroups || 'This bundle is not configured yet.',
              reason: 'shell_selection'
            };
          }
          if (!sels[s].variantId) {
            return {
              ok: false,
              message: messages.needVariants || 'Please choose options for your selected product.',
              reason: 'need_variants'
            };
          }
          if (sels[s].available === false) {
            return {
              ok: false,
              message: messages.unavailable || 'One of the selected items is unavailable.',
              reason: 'unavailable',
              productId: sels[s].productId,
              groupId: g.id
            };
          }
        }
      }
      return { ok: true, message: '', reason: '' };
    }
  };

  function moneyFromCents(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.themeMoneyFormat || undefined);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function BundleApp(root) {
    this.root = root;
    this.config = this.parseConfig();
    this.state = { groups: {} };
    (this.config.groups || []).forEach(function (g) {
      this.state.groups[g.id] = { selections: [] };
    }, this);
    this.isSubmitting = false;
    this.hasInteracted = false;
    this._fetchSeq = {};
    this.cacheEls();
    this.bindEvents();
    this.initDefaultSelections();
    this.syncUI();
  }

  BundleApp.prototype.parseConfig = function () {
    var el = this.root.querySelector('[data-ub-config]');
    try {
      return el ? JSON.parse(el.textContent) : { groups: [], messages: {}, addButtonLabel: 'Add to Bag' };
    } catch (e) {
      return { groups: [], messages: {}, addButtonLabel: 'Add to Bag' };
    }
  };

  BundleApp.prototype.getProductStub = function (productId) {
    if (!productId) return null;
    return this.root.querySelector('[data-ub-product-stub][data-product-id="' + productId + '"]');
  };

  BundleApp.prototype.getProductDescriptionFromDOM = function (productId) {
    var stub = this.getProductStub(productId);
    if (!stub) return '';
    var el = stub.querySelector('[data-ub-product-description]');
    return el ? el.innerHTML.trim() : '';
  };

  BundleApp.prototype.getVariantChosenFromDOM = function (productId, variantId) {
    var stub = this.getProductStub(productId);
    if (!stub || !variantId) return '';
    var el = stub.querySelector('[data-ub-variant-chosen][data-variant-id="' + variantId + '"]');
    return el ? el.innerHTML.trim() : '';
  };

  BundleApp.prototype.resolveSelectionCopy = function (selection) {
    if (!selection) return { description: '', variantDescription: '' };
    var description = this.getProductDescriptionFromDOM(selection.productId) || selection.description || '';
    var variantDescription = this.getVariantChosenFromDOM(selection.productId, selection.variantId) ||
      selection.variantDescription ||
      '';
    if (!variantDescription && selection.variantTitle && selection.variantTitle !== 'Default Title') {
      variantDescription = '<p>' + escapeHtml(selection.title) + ' — ' + escapeHtml(selection.variantTitle) + '</p>';
    }
    return { description: description, variantDescription: variantDescription };
  };

  BundleApp.prototype.initDefaultSelections = function () {
    var self = this;
    this.root.querySelectorAll('[data-ub-group]').forEach(function (groupEl) {
      var blockId = groupEl.getAttribute('data-block-id');
      var meta = self.groupMeta(blockId);
      if (!meta || meta.selectionType === 'optional') return;

      var entry = self.state.groups[blockId];
      if (entry && entry.selections && entry.selections.length) return;

      var trigger = groupEl.querySelector('button[data-ub-product]');
      if (!trigger) {
        trigger = groupEl.querySelector('input[data-ub-product][type="radio"]');
      }
      if (!trigger) {
        var select = groupEl.querySelector('[data-ub-product-select]');
        if (select && select.options.length > 1) trigger = select.options[1];
      }
      if (trigger) self.onProductChosen(groupEl, trigger);
    });
  };

  BundleApp.prototype.cacheEls = function () {
    this.validationEl = this.root.querySelector('[data-ub-validation]');
    this.errorEl = this.root.querySelector('[data-ub-error]');
    this.addButton = this.root.querySelector('[data-ub-add]');
    this.galleryRoot = this.root.querySelector('[data-ub-gallery]');
    this.gallerySlide = this.root.querySelector('.product-card__slide--active') ||
      this.root.querySelector('[data-ub-gallery-slide]');
  };

  BundleApp.prototype.bindEvents = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var ingredientLink = e.target.closest('[data-ingredients-target]');
      if (!ingredientLink) {
        var ingredientRow = e.target.closest('.product-card__ingredients-links li');
        if (ingredientRow && self.root.contains(ingredientRow)) {
          ingredientLink = ingredientRow.querySelector('[data-ingredients-target]');
        }
      }
      if (ingredientLink && self.root.contains(ingredientLink)) {
        e.preventDefault();
        e.stopPropagation();
        self.showIngredientProduct(ingredientLink.getAttribute('data-ingredients-target'));
        return;
      }
      var swatch = e.target.closest('[data-ub-variant-swatch]');
      if (swatch && swatch.tagName === 'BUTTON') {
        e.preventDefault();
        e.stopPropagation();
        self.hasInteracted = true;
        self.onVariantSwatchSelect(swatch.closest('[data-ub-group]'), swatch);
        return;
      }
      var productBtn = e.target.closest('[data-ub-product]');
      if (productBtn && productBtn.tagName === 'BUTTON') {
        e.preventDefault();
        e.stopPropagation();
        self.hasInteracted = true;
        self.onProductChosen(productBtn.closest('[data-ub-group]'), productBtn);
      }
    }, false);
    this.root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[data-ub-product][type="radio"]')) {
        self.hasInteracted = true;
        self.onProductChosen(t.closest('[data-ub-group]'), t);
        return;
      }
      if (t.matches('[data-ub-product-select]')) {
        self.hasInteracted = true;
        var opt = t.options[t.selectedIndex];
        if (!opt || !opt.value) {
          self.clearGroup(t.closest('[data-ub-group]'));
          return;
        }
        self.onProductChosen(t.closest('[data-ub-group]'), opt);
      }
    });
    if (this.addButton) {
      this.addButton.addEventListener('click', function () {
        self.hasInteracted = true;
        self.handleAdd();
      });
    }
  };

  BundleApp.prototype.groupMeta = function (blockId) {
    return (this.config.groups || []).find(function (g) { return g.id === blockId; });
  };

  BundleApp.prototype.clearGroup = function (groupEl) {
    if (!groupEl) return;
    var id = groupEl.getAttribute('data-block-id');
    this.state.groups[id] = { selections: [] };
    groupEl.querySelectorAll('[data-ub-product]').forEach(function (el) {
      if (el.tagName === 'BUTTON') {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      }
      if (el.type === 'radio') el.checked = false;
    });
    var variants = groupEl.querySelector('[data-ub-variants]');
    if (variants) {
      variants.innerHTML = '';
      variants.hidden = true;
    }
    this.updateGroupAvailabilityUI(groupEl, null);
    this.syncUI();
  };

  BundleApp.prototype.isReplaceMode = function (meta) {
    if (!meta) return true;
    if (meta.maxSelection <= 1) return true;
    return meta.displayType === 'radio' || meta.displayType === 'dropdown';
  };

  BundleApp.prototype.applyVariantToSelection = function (selection, variant, productJson) {
    if (!selection || !variant) return;
    selection.variantId = variant.id;
    selection.variantTitle = variant.title;
    selection.price = variant.price;
    selection.variantDescription = this.getVariantChosenFromDOM(selection.productId, variant.id);
    // Availability is always derived from THIS variant only — never from other products.
    selection.available = variant.available === true;
    selection.options = {};
    var slides = productJson ? getVariantGallerySlides(productJson, variant.id) : [];
    var hero = slides[0] || variantImageSrc(variant);
    if (hero) {
      this.updateGallery(hero, variant.title || selection.title || '');
    }
  };

  BundleApp.prototype.applyProductToSelection = function (groupEl, productJson, blockId, selection, variantsMount) {
    selection.description = this.getProductDescriptionFromDOM(selection.productId) || productJson.description || '';
    if (productJson.variants.length === 1) {
      var only = productJson.variants[0];
      this.applyVariantToSelection(selection, only, productJson);
      if (variantsMount) {
        variantsMount.innerHTML = '';
        variantsMount.hidden = true;
      }
      this.updateGroupAvailabilityUI(groupEl, selection);
    } else {
      selection.variantId = null;
      selection.variantTitle = '';
      selection.variantDescription = '';
      selection.price = 0;
      selection.available = null;
      selection.options = {};
      this.renderVariantOptions(variantsMount, productJson, blockId, selection.productId);
      var first =
        productJson.variants.find(function (v) { return v.available === true; }) ||
        productJson.variants[0];
      if (first) {
        this.applyVariantToSelection(selection, first, productJson);
        if (variantsMount) {
          var active = variantsMount.querySelector('[data-variant-id="' + first.id + '"]');
          if (active) {
            active.classList.add('product-card__swatch--active');
            active.setAttribute('aria-checked', 'true');
          }
        }
      }
      this.updateGroupAvailabilityUI(groupEl, selection);
    }
  };

  BundleApp.prototype.onProductChosen = function (groupEl, sourceEl) {
    var self = this;
    if (!groupEl || !sourceEl) return;
    var blockId = groupEl.getAttribute('data-block-id');
    var meta = this.groupMeta(blockId);
    if (!meta) return;

    var handle = sourceEl.getAttribute('data-product-handle');
    var productId = sourceEl.getAttribute('data-product-id');
    var title = sourceEl.getAttribute('data-product-title') || '';
    var featured = sourceEl.getAttribute('data-featured-image') || '';

    this._fetchSeq[blockId] = (this._fetchSeq[blockId] || 0) + 1;
    var fetchSeq = this._fetchSeq[blockId];

    var entry = this.state.groups[blockId] || { selections: [] };
    var replaceMode = this.isReplaceMode(meta);

    if (replaceMode) {
      entry.selections = [];
      groupEl.querySelectorAll('button[data-ub-product]').forEach(function (btn) {
        var on = btn === sourceEl;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    } else {
      var exists = entry.selections.some(function (s) { return String(s.productId) === String(productId); });
      if (exists) {
        entry.selections = entry.selections.filter(function (s) { return String(s.productId) !== String(productId); });
        if (sourceEl.tagName === 'BUTTON') {
          sourceEl.classList.remove('is-selected');
          sourceEl.setAttribute('aria-pressed', 'false');
        }
        var variantsMount = groupEl.querySelector('[data-ub-variants]');
        if (variantsMount) {
          variantsMount.innerHTML = '';
          variantsMount.hidden = true;
        }
        this.state.groups[blockId] = entry;
        this.syncUI();
        if (entry.selections.length) {
          var last = entry.selections[entry.selections.length - 1];
          ProductCache.get(last.handle)
            .then(function (productJson) {
              if (self._fetchSeq[blockId] !== fetchSeq) return;
              self.applyProductToSelection(groupEl, productJson, blockId, last, variantsMount);
              self.state.groups[blockId] = entry;
              self.syncUI();
            })
            .catch(function () {
              if (self._fetchSeq[blockId] !== fetchSeq) return;
              self.showError(self.config.messages.genericError);
            });
        } else {
          this.updateGroupAvailabilityUI(groupEl, null);
        }
        return;
      }
      if (entry.selections.length >= meta.maxSelection) {
        this.showValidation(this.config.messages.maxReached);
        return;
      }
      if (sourceEl.tagName === 'BUTTON') {
        sourceEl.classList.add('is-selected');
        sourceEl.setAttribute('aria-pressed', 'true');
      }
    }

    this.clearError();

    ProductCache.get(handle)
      .then(function (productJson) {
        if (self._fetchSeq[blockId] !== fetchSeq) return;

        var selection = {
          productId: productId,
          handle: handle,
          title: title,
          description: '',
          variantId: null,
          variantTitle: '',
          variantDescription: '',
          price: 0,
          available: null,
          options: {}
        };

        var variantsMount = groupEl.querySelector('[data-ub-variants]');
        self.applyProductToSelection(groupEl, productJson, blockId, selection, variantsMount);

        if (replaceMode) {
          entry.selections = [selection];
        } else {
          entry.selections.push(selection);
        }
        self.state.groups[blockId] = entry;
        self.syncUI();
      })
      .catch(function () {
        if (self._fetchSeq[blockId] !== fetchSeq) return;
        self.showError(self.config.messages.genericError);
      });
  };

  BundleApp.prototype.renderVariantOptions = function (container, productJson, blockId, productId) {
    if (!container) return;
    container.hidden = false;
    container.innerHTML = '';

    var swatches = document.createElement('div');
    swatches.className = 'product-card__swatches';
    swatches.setAttribute('role', 'radiogroup');
    swatches.setAttribute('aria-label', (productJson.title || 'Product') + ' Shades');
    swatches.setAttribute('data-ub-swatches', '');
    swatches.setAttribute('data-product-id', String(productId));
    swatches.setAttribute('data-block-id', blockId);

    (productJson.variants || []).forEach(function (variant) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-card__swatch';
      btn.setAttribute('data-ub-variant-swatch', '');
      btn.setAttribute('data-variant-id', String(variant.id));
      btn.setAttribute('data-product-id', String(productId));
      btn.setAttribute('data-block-id', blockId);
      btn.setAttribute('data-available', variant.available === true ? 'true' : 'false');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-label', variant.title || '');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('title', variant.title || '');
      // Keep swatches clickable even when unavailable (matches product-card).
      // ATC / validation handles sold-out state after selection — per product only.
      if (variant.available === false) {
        btn.classList.add('product-card__swatch--unavailable');
      }

      var imgSrc = variantImageSrc(variant);
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 30;
        img.height = 30;
        btn.appendChild(img);
      } else {
        var dot = document.createElement('span');
        dot.className = 'product-card__swatch-dot';
        dot.setAttribute('aria-hidden', 'true');
        btn.appendChild(dot);
      }
      swatches.appendChild(btn);
    });

    var firstRadio = swatches.querySelector('[role="radio"]');
    if (firstRadio) firstRadio.tabIndex = 0;

    container.appendChild(swatches);
  };

  BundleApp.prototype.onVariantSwatchSelect = function (groupEl, swatchEl) {
    var self = this;
    if (!groupEl || !swatchEl) return;
    var blockId = groupEl.getAttribute('data-block-id');
    var entry = this.state.groups[blockId];
    if (!entry || !entry.selections.length) return;

    var productId = swatchEl.getAttribute('data-product-id');
    var variantId = swatchEl.getAttribute('data-variant-id');
    var selection = entry.selections.find(function (s) {
      return String(s.productId) === String(productId);
    });
    if (!selection) return;

    function applyFromJson(productJson) {
      var variant = VariantResolver.byId(productJson, variantId);
      if (!variant) {
        selection.variantId = null;
        selection.variantDescription = '';
        selection.available = null;
      } else {
        // Updates ONLY this product's selection — other groups/products are untouched.
        self.applyVariantToSelection(selection, variant, productJson);
      }

      var mount = groupEl.querySelector('[data-ub-variants]');
      if (mount) {
        mount.querySelectorAll('[data-ub-variant-swatch][data-product-id="' + productId + '"]').forEach(function (btn) {
          var on = String(btn.getAttribute('data-variant-id')) === String(variantId);
          btn.classList.toggle('product-card__swatch--active', on);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          btn.tabIndex = on ? 0 : -1;
        });
      }

      self.updateGroupAvailabilityUI(groupEl, selection);
      self.state.groups[blockId] = entry;
      self.syncUI();
    }

    var cached = ProductCache._map[selection.handle];
    if (cached) {
      applyFromJson(cached);
      return;
    }

    ProductCache.get(selection.handle)
      .then(applyFromJson)
      .catch(function () {
        self.showError(self.config.messages.genericError);
      });
  };

  BundleApp.prototype.updateGroupAvailabilityUI = function (groupEl, selection) {
    if (!groupEl) return;
    var status = groupEl.querySelector('[data-ub-group-availability]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'product-card__bundle-only-msg';
      status.setAttribute('data-ub-group-availability', '');
      status.setAttribute('aria-live', 'polite');
      status.hidden = true;
      var variants = groupEl.querySelector('[data-ub-variants]');
      if (variants && variants.parentNode) {
        variants.parentNode.insertBefore(status, variants.nextSibling);
      } else {
        groupEl.appendChild(status);
      }
    }

    var isSoldOut = !!(selection && selection.variantId && selection.available === false);
    status.hidden = !isSoldOut;
    status.textContent = isSoldOut ? 'Sold Out' : '';
  };

  BundleApp.prototype.syncGroupAvailabilityUI = function () {
    var self = this;
    this.root.querySelectorAll('[data-ub-group]').forEach(function (groupEl) {
      var blockId = groupEl.getAttribute('data-block-id');
      var entry = self.state.groups[blockId];
      var selection = entry && entry.selections && entry.selections[0] ? entry.selections[0] : null;
      // Prefer the selection that matches currently rendered swatches' product, if any.
      if (entry && entry.selections && entry.selections.length) {
        var mount = groupEl.querySelector('[data-ub-variants]');
        var activeSwatch = mount && mount.querySelector('[data-ub-variant-swatch].product-card__swatch--active');
        if (activeSwatch) {
          var pid = activeSwatch.getAttribute('data-product-id');
          selection = entry.selections.find(function (s) {
            return String(s.productId) === String(pid);
          }) || selection;
        }
      }
      self.updateGroupAvailabilityUI(groupEl, selection);
    });
  };

  BundleApp.prototype.updateGallery = function (url, alt) {
    if (!url) return;
    // Prefer the active slide so multi-image shell galleries stay intact.
    var active = this.root.querySelector('.product-card__slide--active') ||
      this.root.querySelector('[data-ub-gallery-slide]') ||
      this.gallerySlide;
    if (!active) return;
    this.gallerySlide = active;
    var img = active.querySelector('img');
    if (!img) {
      active.innerHTML = '';
      img = document.createElement('img');
      active.appendChild(img);
    }
    var sized844 = shopifySizedImageUrl(url, 844);
    var sized422 = shopifySizedImageUrl(url, 422);
    img.src = sized844;
    img.srcset = sized422 + ' 422w, ' + sized844 + ' 844w';
    img.sizes = '(max-width: 767px) 100vw, 422px';
    img.alt = alt || '';
    img.loading = 'eager';
    img.style.width = '100%';
    img.style.height = 'auto';
    img.style.display = 'block';
  };

  BundleApp.prototype.showValidation = function (message) {
    if (!this.validationEl) return;
    this.validationEl.hidden = !message;
    this.validationEl.textContent = message || '';
  };

  BundleApp.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.hidden = !message;
    this.errorEl.textContent = message || '';
  };

  BundleApp.prototype.clearError = function () {
    this.showError('');
  };

  BundleApp.prototype.collectVariantIds = function () {
    var ids = [];
    var shellProductId = this.config.displayProductId != null
      ? String(this.config.displayProductId)
      : null;
    var groups = this.state.groups;
    Object.keys(groups).forEach(function (key) {
      (groups[key].selections || []).forEach(function (s) {
        if (!s.variantId) return;
        // Never add the display/shell Bundle product — selections should only be group products.
        if (shellProductId && String(s.productId) === shellProductId) return;
        ids.push(Number(s.variantId));
      });
    });
    return ids;
  };

  BundleApp.prototype.syncGroupSummaries = function () {
    var self = this;
    this.root.querySelectorAll('[data-ub-group]').forEach(function (groupEl) {
      var blockId = groupEl.getAttribute('data-block-id');
      var summaryEl = groupEl.querySelector('[data-ub-group-summary]');
      if (!summaryEl) return;

      summaryEl.replaceChildren();
      var entry = self.state.groups[blockId];
      if (!entry || !entry.selections || !entry.selections.length) return;

      entry.selections.forEach(function (s) {
        if (!s.variantId && s.title) {
          var pending = document.createElement('div');
          pending.className = 'product-card__description';
          pending.textContent = s.title + ' (choose options)';
          summaryEl.appendChild(pending);
          return;
        }
        if (!s.variantId) return;

        var copy = self.resolveSelectionCopy(s);
        var item = document.createElement('div');
        item.className = 'product-card__chosen-entry';

        if (copy.description) {
          var desc = document.createElement('div');
          desc.className = 'product-card__description';
          desc.innerHTML = copy.description;
          item.appendChild(desc);
        }

        if (copy.variantDescription) {
          var chosen = document.createElement('div');
          chosen.className = 'product-card__chosen';
          chosen.innerHTML = copy.variantDescription;
          item.appendChild(chosen);
        }

        if (item.childNodes.length) {
          summaryEl.appendChild(item);
        }
      });
    });
  };

  BundleApp.prototype.showIngredientProduct = function (productId) {
    var picker = this.root.querySelector('[data-ingredients-picker]');
    if (!picker || !productId) return;
    var id = String(productId);
    var panel = picker.querySelector('[data-ingredients-panel="' + id + '"]');
    if (!panel) return;

    this.lastIngredientProductId = id;
    picker.querySelectorAll('[data-ingredients-target]').forEach(function (item) {
      var on = item.getAttribute('data-ingredients-target') === id;
      item.classList.toggle('product-card__ingredients-link--active', on);
      item.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    picker.querySelectorAll('[data-ingredients-panel]').forEach(function (item) {
      if (item.getAttribute('data-ingredients-panel') === id) {
        item.removeAttribute('hidden');
      } else {
        item.setAttribute('hidden', '');
      }
    });
  };

  BundleApp.prototype.syncIngredients = function () {
    if (!this.lastIngredientProductId) return;
    this.showIngredientProduct(this.lastIngredientProductId);
  };

  BundleApp.prototype.syncUI = function () {
    var result = Validator.validate(
      this.state,
      this.config.groups || [],
      this.config.messages,
      this.config.displayProductId
    );
    var showMessage = false;
    if (!result.ok) {
      if (result.reason === 'incomplete' || result.reason === 'need_variants') {
        showMessage = this.hasInteracted;
      } else {
        // no_groups, max, shell_selection, unavailable — always surface
        showMessage = true;
      }
    }
    this.showValidation(showMessage ? result.message : '');
    this.syncGroupAvailabilityUI();
    this.syncGroupSummaries();
    this.syncIngredients();

    if (this.addButton && !this.isSubmitting) {
      // Only flip the ATC label to Sold Out when EVERY selected variant is unavailable.
      // A single sold-out product must not mark the whole bundle button as Sold Out
      // if other selected products are still available (or not yet chosen).
      var selectedVariants = [];
      Object.keys(this.state.groups).forEach(function (key) {
        (this.state.groups[key].selections || []).forEach(function (s) {
          if (s.variantId) selectedVariants.push(s);
        });
      }, this);

      var allSelectedSoldOut =
        selectedVariants.length > 0 &&
        selectedVariants.every(function (s) { return s.available === false; });

      this.addButton.disabled = !result.ok;
      var addLabel = (allSelectedSoldOut && result.reason === 'unavailable')
        ? 'Sold Out'
        : (this.config.addButtonLabel || 'Add to Bag');
      this.addButton.textContent = addLabel;
      var productName = this.addButton.getAttribute('data-product-title') || '';
      this.addButton.setAttribute('aria-label', productName ? productName + ' ' + addLabel : addLabel);
    }
  };

  BundleApp.prototype.handleAdd = function () {
    this.hasInteracted = true;
    var result = Validator.validate(
      this.state,
      this.config.groups || [],
      this.config.messages,
      this.config.displayProductId
    );
    if (!result.ok) {
      this.showValidation(result.message);
      return;
    }
    this.submitCart();
  };

  BundleApp.prototype.submitCart = function () {
    var self = this;
    var rawCount = 0;
    Object.keys(this.state.groups).forEach(function (key) {
      (this.state.groups[key].selections || []).forEach(function (s) {
        if (s.variantId) rawCount += 1;
      });
    }, this);
    var ids = this.collectVariantIds();
    if (!ids.length || ids.length !== rawCount) {
      this.showValidation(
        (this.config.messages && this.config.messages.incompleteRequired) ||
          'Please complete all required selections.'
      );
      return;
    }
    this.clearError();
    this.isSubmitting = true;
    if (this.addButton) {
      this.addButton.disabled = true;
      this.addButton.textContent = this.config.loadingLabel || 'Adding…';
    }
    CartService.addItems(ids)
      .then(function (result) {
        if (!result.ok) {
          var msg =
            (result.data && (result.data.description || result.data.message)) ||
            (self.config.messages && self.config.messages.genericError) ||
            'Could not add your bundle. Please try again.';
          self.showError(msg);
          self.isSubmitting = false;
          self.syncUI();
          return;
        }
        // Success: both (or more) line items were accepted by Shopify.
        try { sessionStorage.setItem('madkind-open-cart', '1'); } catch (e) {}
        window.location.reload();
      })
      .catch(function () {
        self.showError(
          (self.config.messages && self.config.messages.genericError) ||
            'Could not add your bundle. Please try again.'
        );
        self.isSubmitting = false;
        self.syncUI();
      });
  };

  var CartService = {
    addItems: function (variantIds) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var payload = {
        items: variantIds.map(function (id) {
          return { id: Number(id), quantity: 1 };
        })
      };
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response
          .json()
          .catch(function () {
            return { description: 'Could not add your bundle. Please try again.' };
          })
          .then(function (data) {
            return { ok: response.ok, status: response.status, data: data };
          });
      });
    }
  };

  function initRoot(root) {
    if (!root || root.getAttribute('data-ub-ready') === 'true') return;
    root.setAttribute('data-ub-ready', 'true');
    new BundleApp(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-universal-bundle]').forEach(initRoot);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  window.MadkindUniversalBundle = {
    ProductCache: ProductCache,
    VariantResolver: VariantResolver,
    Validator: Validator,
    CartService: CartService,
    BundleApp: BundleApp,
    init: initRoot,
    initAll: initAll
  };
})(window, document);
